import {combineReducers} from 'redux';
import commonState from "./common-state";
import eventState from "./event-state";

export default combineReducers({
    commonState,
    eventState
});